import airports from 'data/translations/de/airports.json';
import attributes from 'data/translations/de/attributes.json';
import common from 'data/translations/de/common.json';
import countries from 'data/translations/de/countries.json';
import faqs from 'data/translations/de/faqs.json';
import hints from 'data/translations/de/hints.json';

export const translationDe = {
    ...common,
    ...attributes,
    ...hints,
    ...airports,
    ...countries,
    ...faqs,
};

export type TranslationKeys = keyof typeof translationDe;
